<div class="container-fluid">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">Details</span>
  </nav>
</div>

<div class="container-fluid p-0">
  <div *ngIf="contractorService.contractor; else showLoader">
    <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">

      <div class="card rounded-0">
        <div class="card-body">

          <div class="row pt-3">
            <div class="col-12 col-xl-6">
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Company Name</mat-label>
                    <input
                      matInput
                      placeholder="Company Name"
                      [(ngModel)]="contractorService.contractor.name"
                      name="name"
                      type="text"
                      id="name"
                      required/>
                    <mat-hint>Enter the {{ utils.getLangTerm('contractors.singular', 'Contractor') }} name.</mat-hint>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Industry</mat-label>
                    <mat-select
                      matInput
                      placeholder="Industry"
                      [(ngModel)]="contractorService.contractor.industry"
                      name="industry"
                      id="industry">
                      <mat-option *ngFor="let industry of industries" [value]="industry.name">{{ industry.name }}</mat-option>
                    </mat-select>
                    <mat-hint>Select the industry of the {{ utils.getLangTerm('contractors.singular', 'Contractor') }}.</mat-hint>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-12 col-xl-6">

              <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Address</mat-label>
                <input
                  matInput
                  placeholder="Address"
                  [(ngModel)]="contractorService.contractor.address"
                  name="address"
                  type="text"
                  id="address"/>
                <mat-hint>Enter the address of the {{ utils.getLangTerm('contractors.singular', 'Contractor') }}.</mat-hint>
              </mat-form-field>

              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('accounts.form.suburb', 'Suburb') }}</mat-label>
                    <input
                      matInput
                      [placeholder]="utils.getLangTerm('accounts.form.suburb', 'Suburb')"
                      [(ngModel)]="contractorService.contractor.suburb"
                      name="suburb"
                      type="text"
                      id="suburb"/>
                    <mat-hint>Enter the {{ utils.getLangTerm('accounts.form.suburb', 'Suburb') }} of the {{ utils.getLangTerm('contractors.singular', 'Contractor') }}.</mat-hint>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('accounts.form.city', 'City') }}</mat-label>
                    <input
                      matInput
                      [placeholder]="utils.getLangTerm('accounts.form.city', 'City')"
                      [(ngModel)]="contractorService.contractor.city"
                      name="city"
                      type="text"
                      id="city"/>
                    <mat-hint>Enter the {{ utils.getLangTerm('accounts.form.city', 'City') }} of the {{ utils.getLangTerm('contractors.singular', 'Contractor') }}.</mat-hint>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('accounts.form.postal_code', 'Postal Code') }}</mat-label>
                    <input
                      matInput
                      [placeholder]="utils.getLangTerm('accounts.form.postal_code', 'Postal Code')"
                      [(ngModel)]="contractorService.contractor.postal_code"
                      name="postal_code"
                      type="text"
                      id="postal_code"/>
                    <mat-hint>Enter the {{ utils.getLangTerm('accounts.form.postal_code', 'Postal Code') }} of the {{ utils.getLangTerm('contractors.singular', 'Contractor') }}.</mat-hint>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Country</mat-label>
                    <input
                      matInput
                      placeholder="Country"
                      [(ngModel)]="contractorService.contractor.country"
                      name="country"
                      type="text"
                      id="country"/>
                    <mat-hint>Enter the country of the {{ utils.getLangTerm('contractors.singular', 'Contractor') }}.</mat-hint>
                  </mat-form-field>
                </div>
              </div>

            </div>
          </div>

          <div class="row mt-2">
            <div class="col">
              <button
                mat-raised-button
                class="my-2 ml-0 mr-2"
                [disabled]="!f.valid"
                (click)="onSubmit(f)"
                type="button"
                color="primary"
                id="update_button">
                <mat-icon>save</mat-icon>
                Update
              </button>
            </div>
          </div>

        </div>
      </div>

    </form>
  </div>
  <ng-template #showLoader>
    <div class="d-flex justify-content-center align-items-center full-height">
      <table>
        <tr>
          <td class="d-flex justify-content-center">
            <mat-progress-spinner [mode]="'indeterminate'" diameter="32"></mat-progress-spinner>
          </td>
        </tr>
        <tr>
          <td class="d-flex justify-content-center">
            <p>Please wait while we get the information...</p>
          </td>
        </tr>
      </table>
    </div>
  </ng-template>
</div>
